import { Component, h, Host, Prop } from "@stencil/core";
import {getColorByToken} from "../../utils/tokens";

@Component({
	tag: "smart-features-list-item",
	styleUrl: "smart-features-list-item.scss",
	shadow: true,
})

export class SmartFeaturesListItem {
	private variations = {
		checkedIcon: {
			icon: "ph-check-circle",
			iconColor: getColorByToken("color-action-success")
		},
		uncheckedIcon: {
			icon: "ph-prohibit",
			iconColor: getColorByToken("color-base-gray-gray-4")
		}
	};

	@Prop({ mutable: false }) checkedIcon = true;

	render() {
		const variation = this.checkedIcon ? this.variations.checkedIcon : this.variations.uncheckedIcon;
		return (
			<Host>
				<li class={`smart-features-list-item smart-features-list-item--${this.checkedIcon ? "checked" : "unchecked"}`}>
					<smart-icon 
						phosphorIcon={variation.icon}
						color={variation.iconColor}
						size={20}
					></smart-icon>
					<smart-text part="text" variant='bodytext-1' as="p"><slot></slot></smart-text>
				</li>
			</Host>
		);
	}

}
